import React from 'react';
import NuAmount from '../../../../Components/Utils/NuAmount';
import { Link } from 'react-router-dom';
import { BackButton, EditButton } from '../../../../Components/Utils/Buttons';

function RentalManpowerView({ item, data, open, onCancel }) {
  const displayItem = item || data;

  return (
    <div className="w-full h-full py-2 px-4 ">
   <div className="flex justify-end ">
    {/* <Breadcrumb
            items={[
              // { name: "Sales" },
      
              { name: "Client",
                link:`/main/${officeId}/contacts/customers ` },
                
              { name: "View"},
            
        ]} /> */}
          <div className=" flex gap-2">
            <Link 
            // to={`/main/${officeId}/contacts/customers`} 
            // state={{currentPage:pageIndex,searchQuery:searchQuery!=""?searchQuery:""}}
            ><BackButton link={true}/></Link>
            <Link
            //  to={`/main/${officeId}/contacts/customers/edit/${customersViewId}`} 
            // state={{data: data, from:`/main/${officeId}/contacts/customers/view/${customersViewId}`}}
            ><EditButton height='8'/></Link>
          </div>
   </div>
    <div className="w-full flex justify-between flex-wrap gap-5">
      <div className='my-2 w-[40%]'>
        <p className='text-[13px] font-medium text-mainColor-400 py-1'>Job Role</p>
        <p className='text-xs text-mainColor-400'>{displayItem?.job_role || "-"}</p>
      </div>
      <div className="my-2 w-[40%]">
  <p className="text-[13px] font-medium text-mainColor-400 py-1">Type</p>
  <p className="text-xs text-mainColor-400">
    {displayItem?.type === 0 ? "Own" : displayItem?.type === 1 ? "Rental" : "-"}
  </p>
</div>
</div>
<div className="w-full flex justify-between flex-wrap gap-5">

      <div className='my-2 w-[40%]'>
        <p className='text-[13px] font-medium text-mainColor-400 py-1'>Working Hours</p>
        <p className='text-xs text-mainColor-400'>{displayItem?.working_hours || "-"}</p>
      </div>
       <div className='my-2 w-[40%]'>
        <p className='text-[13px] font-medium text-mainColor-400 py-1'>Amount Per Hour</p>
        <p className='text-xs text-mainColor-400'><NuAmount value={displayItem?.amount_per_hour || "-"}/></p>
      </div>
    </div>
    </div>
  );
}
 
export default RentalManpowerView;
